import moment from 'moment/moment';

export const range = (start: number, end: number) => Array.from({ length: end - start + 1 }, (v, k) => k + start);

export const dateTimeFormat = ({ date, format = 'YYYY/MM/DD HH:mm' }: { date: string; format?: string }) => {
  return moment(date).format('YYYY/MM/DD HH:mm');
};

export const dateFormat = ({ date, format = 'YYYY/MM/DD' }: { date: string; format?: string }) => {
  return moment(date).format('YYYY/MM/DD');
};

export const stripTags = (value: string) => {
  return value.replace(/(<([^>]+)>)/gi, '');
};

export const scrollTop = () => {
  window.scrollTo(0, 0);
};

export const isValidURL = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
};

export const isBackofficeURL = (url: string) => {
  return url.includes('/backoffice/');
};

export const isApprovalURL = (url: string) => {
  return url.includes('/approval/');
};

export const objectToQueryString = (obj: any) => {
  if (!obj) return '';

  return Object.entries(obj).reduce((queryString, [key, val], i) => {
    if (val) {
      const symbol = queryString.length == 0 ? '' : '&';
      if (Array.isArray(val)) {
        const _qs = val.map((d, i) => `${key}[]=${val[i]}`).join('&');
        return _qs.length > 0 ? `${queryString}${symbol}${_qs}` : queryString;
      } else {
        return `${queryString}${symbol}${key}=${val}`;
      }
    } else {
      return queryString;
    }
  }, '');
};
